// @mui
import { Theme, SxProps } from '@mui/material/styles';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import OutlinedInput from '@mui/material/OutlinedInput';
import Select from '@mui/material/Select';
import { useCallback } from 'react';

// ----------------------------------------------------------------------

type Props = {
  size: any;
  label: string;
  name: string;
  options: any;
  valueFilter: any;
  onFilters: any;
  sx?: SxProps<Theme>;
};

export default function FilterTableData({
  size,
  label,
  name,
  options,
  valueFilter,
  onFilters,
  sx,
}: Props) {
  const values = [...valueFilter];

  const handleFilter = useCallback(
    (event: any) => {
      console.log('select event', event, valueFilter);
      // const newValue = event.target.value;
      // const indexOfNewValue = valueFilter.findIndex((value: any) => value.value === newValue.value);
      // if (indexOfNewValue === -1) valueFilter = [...valueFilter, newValue];
      // else {
      //   valueFilter.splice(indexOfNewValue, 1);
      // }

      onFilters(
        name,
        typeof event.target.value === 'string' ? event.target.value.split(',') : event.target.value
      );
    },
    [onFilters]
  );

  return (
    <FormControl
      sx={{
        flexShrink: 0,
        width: '100%',
        ...sx,
      }}
    >
      <InputLabel size={size}>{label}</InputLabel>

      <Select
        size={size}
        multiple
        value={values}
        onChange={handleFilter}
        input={<OutlinedInput label={label} />}
        renderValue={(selected) =>
          selected
            .map((value: any) => options.find((option: any) => option.value === value)?.label)
            .join(', ')
        }
        MenuProps={{
          PaperProps: {
            sx: {
              maxHeight: 240,
            },
          },
        }}
      >
        {options?.map((option: any) => (
          <MenuItem key={option?.value} value={option?.value}>
            <Checkbox
              disableRipple
              size="small"
              checked={valueFilter?.some((filter: any) => filter === option?.value)}
            />
            {option?.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
